import axios, { getEnv } from '../../../services/api';
import Axios from 'axios';

export const AtendimentoService = {
    findAll: async (params, body = {}, source) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/relatorio-atendimentos`,
                body,
                {
                    params,
                    cancelToken: source?.token,
                }
            );
            return response.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada', error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },

    find: async (id) => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/atendente/${id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    findCPF: async (cpf) => {
        try {
            const response = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/integracao/sas/pessoa-fisica?cpf=${cpf}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    findUF: async (uf) => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/ufs/sebrae/${uf}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },


    update: async (body) => {
        return await axios.put(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan`,
            body
        );
    },

    changeStatus: async (idAtendente, status) => {
        const params = {idAtendente, status};
        try {
            return await axios.put(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/atendente/alterar-status`,
                {},
                {params}
            );
        } catch (error) {
            throw error;
        }
    },
    delete: async (id, inativo = true) => {
        return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/inativar?id=${id}&inativo=${inativo}`);
    },

    getFilterOptions: async (consulta = false) => {
        try {
            const response = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/atendimentos/opcoes?consulta=${consulta}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    findAcoesByUF: async (siglaUf) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/sas/projetos/acoes/${siglaUf}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};
